import { useEffect, useState } from "react";

import { siteLocationPrefix } from "./urls";

export const signInUrl = `${siteLocationPrefix}/auth/login`;

export const signOutUrl = `${siteLocationPrefix}/auth/logout`;

export const profileUrl = `${siteLocationPrefix}/auth/profile`;

export const switchAccountUrl = `${siteLocationPrefix}?prompt=login`;

export const useSignInUrlWithCallback = (callbackUrl: string) => {
  const [signInUrlWithCallback, setSignInUrlWithCallback] = useState("");
  useEffect(() => {
    if (!signInUrlWithCallback) {
      setSignInUrlWithCallback(`${signInUrl}?callbackUrl=${window.location.origin}${callbackUrl}`);
    }
  }, [callbackUrl, signInUrlWithCallback]);
  return signInUrlWithCallback;
};
